import React from 'react'
import ReactDOM from 'react-dom/client'
import WebInternalAppRoot from './app/WebInternalAppRoot'

import nullthrows from 'nullthrows'

const container = document.getElementById('root')
const root = ReactDOM.createRoot(nullthrows(container))
root.render(<WebInternalAppRoot />)
